import { Box, Divider, Stack, useMediaQuery } from "@mui/material";
import React from "react";
import Staking from "./Staking";

export default function StakingMain() {
  const matches = useMediaQuery("(max-width:750px)");

  return (
    <>
      <Box mb={15} id="staking">
        <Stack pt={matches ? 0 : 10} ml={matches ? 0 : 15}>
          <Staking />
        </Stack>
      </Box>
    </>
  );
}
